"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.formula = exports.ExpressionParser = void 0;
const ExpressionParser_1 = require("./ExpressionParser");
exports.ExpressionParser = ExpressionParser_1.default;
const formula_1 = require("./languages/formula");
Object.defineProperty(exports, "formula", { enumerable: true, get: function () { return formula_1.formula; } });
exports.init = (language, evalTerm, typeTerm) => {
    const defn = language(evalTerm, typeTerm);
    return new ExpressionParser_1.default(defn);
};
//# sourceMappingURL=index.js.map